module.exports = __webpack_public_path__ + "img/submitIcon.09838706.svg";